var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.56055 0.862305L4.03125 3.3916L1.50195 0.862305C1.41992 0.771159 1.31738 0.725586 1.19434 0.725586C1.07129 0.725586 0.96875 0.771159 0.886719 0.862305C0.795573 0.944336 0.75 1.0446 0.75 1.16309C0.75 1.28158 0.795573 1.38639 0.886719 1.47754L3.7168 4.30762C3.76237 4.35319 3.8125 4.38737 3.86719 4.41016C3.92188 4.43294 3.97656 4.44434 4.03125 4.44434C4.08594 4.44434 4.14062 4.43294 4.19531 4.41016C4.25 4.38737 4.30013 4.35319 4.3457 4.30762L7.17578 1.47754C7.26693 1.38639 7.3125 1.28158 7.3125 1.16309C7.3125 1.0446 7.26693 0.944336 7.17578 0.862305C7.09375 0.771159 6.99121 0.725586 6.86816 0.725586C6.74512 0.725586 6.64258 0.771159 6.56055 0.862305Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.7128244d57965100a231eec9075a753b.svg";
export { ForwardRef as ReactComponent };